import { useParams } from 'next/navigation';
import { Order } from 'shared/types/cart/Order';
import Typography from 'components/gruenland/atoms/typography';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import { useFormat } from 'helpers/hooks/useFormat';
import OrderItemsList from '../../order-items-listing/OrderItemsList';
import useCostsData from '../../order-payment-section/hooks/useCostsData';

type Props = {
  order: Order;
};

const ThankyoupageOrderSummary: React.FC<Props> = ({ order }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const { locale } = useParams();

  const { loading, costsToRender, total } = useCostsData({ dataReference: 'order', order });

  return (
    <div className="grow bg-white px-4 md:px-6 lg:p-9">
      <div className="my-4 md:mb-0 md:border-b md:border-neutral-400 md:pb-4 md:text-[18px] lg:m-0 lg:border-b-0 lg:pb-7">
        <Typography as="h4" asSkeleton={!order.sum} className="w-fit text-[18px] leading-[20px] text-primary-black">
          {formatMessage({ id: 'order.details', defaultMessage: 'Dettagli ordine' })}
        </Typography>
      </div>

      <OrderItemsList lineItems={order.lineItems || []} />

      {/* Order summary info */}
      <div className="grid gap-2 border-t border-neutral-400 bg-white py-4 lg:pt-8">
        {costsToRender.map(
          ({ key, label, value }) =>
            !!value?.centAmount &&
            value.centAmount > 0 && (
              <div key={key} className="flex items-center justify-between">
                <Typography asSkeleton={loading} className="text-[14px] text-primary-black md:text-[16px]">
                  {label}
                </Typography>
                <Typography asSkeleton={loading} className="text-[14px] text-primary-black md:text-[16px]">
                  {CurrencyHelpers.formatForCurrency(value, locale)}
                </Typography>
              </div>
            ),
        )}

        <div className="mt-4 flex items-center justify-between lg:mt-3 lg:border-t lg:border-neutral-400 lg:pt-3">
          <Typography asSkeleton={loading} className="font-medium text-primary-black md:text-[18px] lg:leading-loose">
            {total.label + ':'}
          </Typography>
          <Typography asSkeleton={loading} className="font-medium text-primary-black md:text-[18px] lg:leading-loose">
            {CurrencyHelpers.formatForCurrency(total.value, locale)}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ThankyoupageOrderSummary;
